import { createSelector } from 'reselect';
import { lineLoadingSelector, selectedHubDataSelector, selectedHubSerialSelector } from '../selectors';

/**
 * Memoized selector that aggregates hub serial, hub data, and line loading status
 * for use on the Virtual Devices page.
 *
 * Combines the selected hub's serial number, its data, and the current line loading status
 * into a single object for convenient access.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {string|null} serial - The serial number of the selected hub, or null if not available.
 *   @property {Object|null} controllerData - The data object for the selected hub, or null if not available.
 *   @property {boolean} lineLoading - Whether a line is currently loading.
 *
 * @example
 * const { serial, controllerData, lineLoading } = useSelector(virtualDevicesPageLoadingSelector);
 */
export const virtualDevicesPageLoadingSelector = createSelector(
    [selectedHubSerialSelector, selectedHubDataSelector, lineLoadingSelector],
    (serial, controllerData, lineLoading) => ({
        serial,
        controllerData,
        lineLoading,
    }),
);
